import { createStack } from './stack';
import { State } from './state';
export function createSerializer(schema, specMap, remark) {
    return (content) => {
        const state = new State(createStack(), schema, specMap);
        state.run(content);
        return state.toString(remark);
    };
}
export * from './types';
//# sourceMappingURL=index.js.map